import { createCalculatorApp } from './create-calculator-component';
import type { CalculatorConfig } from './types';

export function mount(config: CalculatorConfig): void {
	if (!config?.appId) {
		return;
	}

	if (!BX.Vue3?.BitrixVue) {
		console.error('[fte.calculator] BX.Vue3.BitrixVue is not available. Load ui.vue3 extension.');
		return;
	}

	const mountNode = document.getElementById(config.appId);
	if (!mountNode) {
		console.error('[fte.calculator] Mount node not found:', config.appId);
		return;
	}

	if ((mountNode as HTMLElement & { __fteCalculatorMounted?: boolean }).__fteCalculatorMounted) {
		return;
	}

	(mountNode as HTMLElement & { __fteCalculatorMounted?: boolean }).__fteCalculatorMounted = true;

	createCalculatorApp(config).mount(`#${config.appId}`);
}
